
export const describeKeys = 'ssh/apiDescribeKeys';
export const createKey = 'ssh/apiCreateKey';
export const deleteKey = 'ssh/apiDeleteKey';
export const importKey = 'ssh/apiImportKey';
export const detachKey = 'ssh/apiDetachKey';
export const attachKey = 'ssh/apiAttachKey';
export const CheckKeyEncryption = 'ssh/CheckKeyEncryption';
export const DetachInstanceKey = 'ssh/DetachInstanceKey';
